import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

import './styles.css';

const propTypes = {
  icon: PropTypes.string,
  skin: PropTypes.oneOf([
    'transparent',
    'primary',
    'secondary',
    'gray-light',
    'danger',
    'warning',
    'success',
    'white',
  ]),
  text: PropTypes.string,
  outline: PropTypes.bool,
  block: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  textCapitalize: PropTypes.bool,
  size: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

const defaultProps = {
  icon: null,
  skin: null,
  text: null,
  outline: false,
  block: false,
  className: null,
  disabled: false,
  textCapitalize: false,
  size: null,
  onClick: null,
  type: null,
};

class Button extends Component {
  render() {
    const {
      className,
      skin,
      icon,
      text,
      block,
      outline,
      disabled,
      textCapitalize,
      textLowerCase,
      noWidth,
      size,
      onClick,
      type,
      children,
    } = this.props;

    return (
      <button
        disabled={disabled}
        className={
          `Button${' '}
          ${block ? ' Button--block ' : ''}
          ${outline ? 'Button--outline ' : ''}
          ${skin ? `Button--${skin} ` : ''}
          ${textCapitalize ? 'Button--text-capitalize ' : ''}
          ${textLowerCase ? 'Button--text-lowercase ' : ''}
          ${size ? `Button--${size} ` : ''}
          ${noWidth ? 'Discharges__header-subtitle-actions__button_no-width' : ''}
          ${className || ''}`
        }
        type={type}
        onClick={onClick}
      >
        {icon && <Icon className="Button__icon" name={icon} />}
        {text && <span className="Button__text">{text}</span>}
        {children}
      </button>
    );
  }
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
